import { JoonUIColor, SPACING, TextArea, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { useCancelModalStore } from "./CancelModal"

const SurveyStep = ({
  scrollRef,
}: {
  scrollRef: React.RefObject<HTMLDivElement>
}) => {
  const {
    steps,
    stepIndex,
    selectedAnswerIndex,
    setSelectedAnswerIndex,
    freeformAnswer,
    setFreeformAnswer,
  } = useCancelModalStore()
  const { t } = useTranslation()

  const cancelFlowStep = steps[stepIndex]

  const onSelectAnswer = (index: number) => {
    setSelectedAnswerIndex(index)
    setTimeout(() => {
      scrollRef.current?.scrollTo({
        top: scrollRef.current?.scrollHeight,
        behavior: "smooth",
      })
    }, 100)
  }

  return (
    <>
      <Typography variant="h3">{t("SURVEY_WHY_CANCELING")}</Typography>
      <Typography variant="bodySmall">
        {selectedAnswerIndex === null
          ? t("SURVEY_LOVE_FEEDBACK")
          : t("SURVEY_HELP_IMPROVE")}
      </Typography>
      <div className="flex flex-col gap-2 w-full">
        {cancelFlowStep.survey_answers?.map((answer, index) => (
          <SurveyAnswerButton
            answer={answer.answer}
            key={answer.answer}
            onClick={() => onSelectAnswer(index)}
            isSelected={selectedAnswerIndex === index}
          />
        ))}
        {selectedAnswerIndex !== null && (
          <div className="flex flex-col gap-2 w-full mt-2">
            <Typography variant="bodySmall">
              {
                cancelFlowStep.survey_answers?.[selectedAnswerIndex]
                  .freeform_title
              }
            </Typography>
            <TextArea
              name="freeformAnswer"
              placeholder={t("SURVEY_FREEFORM_PLACEHOLDER")}
              value={freeformAnswer}
              onChange={(e) => setFreeformAnswer(e.target.value)}
              fullWidth
              style={{
                borderRadius: SPACING.space2,
                padding: SPACING.space3,
                color: JoonUIColor.text.primary,
              }}
            />
          </div>
        )}
      </div>
    </>
  )
}

const SurveyAnswerButton = ({
  answer,
  onClick,
  isSelected,
}: {
  answer: string
  onClick: () => void
  isSelected: boolean
}) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background:
          !isHovered || isSelected
            ? JoonUIColor.background.primaryNeutral
            : JoonUIColor.background.xlightGray,
        border: isSelected
          ? `1px solid ${JoonUIColor.border.accent}`
          : `1px solid ${JoonUIColor.border.default}`,
        color: isSelected
          ? JoonUIColor.text.primaryAccent
          : JoonUIColor.text.primary,
        borderRadius: SPACING.space2,
        padding: SPACING.space3,
        paddingTop: SPACING.space2,
        paddingBottom: SPACING.space2,
        width: "100%",
        minHeight: "48px",
        transition: "border, background 0.3s ease-in-out",
        userSelect: "none",
        pointerEvents: isSelected ? "none" : "auto",
        cursor: isSelected ? "not-allowed" : "pointer",
      }}
      onClick={onClick}
    >
      <Typography
        variant="bodySmall"
        textAlign="center"
        style={{
          width: "100%",
          height: "100%",
          color: isSelected
            ? JoonUIColor.text.primaryAccent
            : JoonUIColor.text.primary,
        }}
      >
        {answer}
      </Typography>
    </button>
  )
}

export default SurveyStep
